export enum ThumbnailAward {
  Gold = 'gold',
  Silver = 'silver',
  Bronze = 'bronze',
  Completed = 'completed'
}
